import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import { IGateStore, IGate } from '../storeInterfaces/gateStoreInterface';
import { gatesPath, getGatebyId, updateGateStatus } from '../../axios/branchGatesRequests';
import { WeekDays } from '../storeInterfaces/customerServiceStoreInterface';
import { RequestStatus } from 'mobx-store';

export class GatesStore implements IGateStore {

  @observable gatesList: any[] = [];

  @observable selectedGate: any = {};

  @observable loading = false;

  @observable getBranchesGatesRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getGates(countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      this.getBranchesGatesRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
      };

      const config = {
        ...getHeader(langCode), params,
      };
      
      const response = await Connections.wadiDeglaAxios.httpGet(gatesPath, config);
      this.gatesList = response.data;
      this.getBranchesGatesRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getBranchesGatesRequestStatus = RequestStatus.FAILED;
      console.log(error);

      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async getGatebyId(gateId: number, langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;

      const config = {
        ...getHeader(langCode),
      };
      
      const response = await Connections.wadiDeglaAxios.httpGet(getGatebyId(gateId), config);
      this.selectedGate = this.restructureWorkingHours(response.data);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  restructureWorkingHours(data: IGate) {
    let gateOpenTimeIntervals: any[] = [];
    for(let day in WeekDays) {
      const _day = day.replace(day.substring(1), day.substring(1).toLowerCase());
      const slot = data.gateOpenTimeIntervals.filter(slot => slot.day == _day)[0];
      if(slot) {
        gateOpenTimeIntervals.push({
          day: _day,
          isOpen: !!slot.startTime,
          startTime: slot.startTime,
          endTime: slot.endTime
        });  
      } else {
        gateOpenTimeIntervals.push({
          day: _day,
          isOpen: false,
          startTime: null,
          endTime: null
        });  
      }
    } 

    return {
      ...data, 
      branchId: data.branch.branchId, 
      gateOpenTimeIntervals, 
      isActive: data.isActive,
      title: data.title,
    }
  }

  @action
  public async createGate(newGate: any, langCode: string = DefaultLanguage, availableCountries: ICountry[]): Promise<any> {
      console.log("langCode", langCode)
      // this.loading = true;
      const config = {
        ...getHeader(langCode),
      };
      const countries = convertCountriesToISOCodeString(availableCountries);
      const res = await Connections.wadiDeglaAxios.httpPost(gatesPath, {...newGate, availableCountries: [countries]}, config);
      // this.loading = false;
      
      return res.data;
  }
  
  @action
  public async updateGate(updatesGate: any, langCode: string = DefaultLanguage): Promise<any> {

      // this.loading = true;
      const config = {
        ...getHeader(langCode),
      };    
      await Connections.wadiDeglaAxios.httpPut(gatesPath, updatesGate, config);
      // this.loading = false;
  }

  @action
  public async updateGateStatus(value: boolean, index: number): Promise<any> {

      this.loading = true;
      try {
        await Connections.wadiDeglaAxios.httpPut(updateGateStatus(this.gatesList[index].gateId), {
          isActive: value,
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.gatesList[index].isActive = value;
        this.loading = false;
      }  
  }

}
